<template>
  <main>
    <form
      class="form-entrar"
      @submit.prevent="logar"
    >
      <nav
        class="btn-voltar"
        aria-label="Navegação de retorno"
      >
        <router-link to="/login">Voltar</router-link>
      </nav>

      <h1>Entrar no GEX</h1>

      <div>
        <label for="login">Login SIGAA:</label>
        <input
          id="login"
          class="input-login"
          type="text"
          v-model="usuario"
          required
          autofocus
        />
      </div>

      <div>
        <label for="senha">Senha SIGAA:</label>
        <input
          id="senha"
          class="input-login"
          type="password"
          v-model="senha"
          required
        />
      </div>

      <div id="div-links">
        <a
          href="https://si3.ufc.br/admin/public/recuperar_login.jsf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Não tenho cadastro ou esqueci meu login SIGAA
        </a>

        <a
          href="https://si3.ufc.br/admin/public/recuperar_senha.jsf"
          target="_blank"
          rel="noopener noreferrer"
        >
          Esqueci minha senha SIGAA
        </a>
      </div>

      <button
        class="submit-login"
        type="submit"
        :disabled="loading"
      >
        {{ loading ? "Carregando..." : "Entrar" }}
      </button>

      <div
        id="div-validacao"
        v-if="erro"
        aria-live="assertive"
        role="alert"
      >
        {{ erro }}
      </div>
    </form>
  </main>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { autenticarUsuarioSigaa } from "@/composables/autenticacaoSigaa";

const usuario = ref("");
const senha = ref("");
const loading = ref(false);
const erro = ref("");

const router = useRouter();

async function logar() {
  // event.preventDefault() removido daqui por já estar no template (.prevent)
  loading.value = true;
  erro.value = "";

  try {
    const resultado = await autenticarUsuarioSigaa(usuario.value, senha.value);

    if (resultado?.perfilUser?.success) {
      const data = resultado.perfilUser.data;
      const tokenGEX =
        data?.token || data?.accessToken || resultado.tokens?.accessToken;

      if (tokenGEX) {
        router.push("/");
      } else {
        console.error("Token não encontrado na resposta do GEX!", data);
        erro.value = "Erro: Token não recebido do servidor.";
      }
    } else {
      erro.value =
        resultado?.perfilUser?.message || "Usuário ou senha incorretos.";
      senha.value = "";
    }
  } catch (error) {
    console.error("Erro crítico no login:", error);
    erro.value = "Ocorreu um erro inesperado. Tente novamente mais tarde.";
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", Avenir, Helvetica, Arial, sans-serif;
}

.login-layout {
  background: linear-gradient(
    90deg,
    var(--roxo-primario) 0%,
    var(--roxo-medio) 100%
  );
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.form-entrar {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  background: var(--branco);
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px hsla(0, 0%, 0%, 0.15);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 420px;
  animation: fadeIn 0.4s ease-in-out;
}

/* Título */
.form-entrar h1 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--roxo-primario);
  text-align: center;
}

/* Botão voltar */
.btn-voltar a {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  background: var(--roxo-primario);
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 500;
  color: var(--branco);
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-voltar a::before {
  content: "←";
  font-size: 0.9rem;
}

.btn-voltar a:hover {
  background: var(--roxo-medio);
  color: white;
}

.btn-voltar a:active {
  background: var(--roxo-primario);
}

.form-entrar label {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--cinza-escuro);
  margin-bottom: 0.3rem;
  display: block;
}

.input-login {
  width: 100%;
  padding: 0.9rem 1rem;
  border: 1px solid var(--cinza-claro);
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 400;
  color: var(--preto);
  outline: none;
  transition:
    border 0.3s ease,
    box-shadow 0.3s ease;
}

.input-login:focus {
  border-color: var(--roxo-medio);
  box-shadow: 0 0 0 3px hsla(258, 46%, 46%, 0.2);
}

/* Botão Entrar */
.submit-login {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--branco);
  background: var(--roxo-primario);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-login:hover {
  background: var(--roxo-medio);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px hsla(258, 46%, 46%, 0.3);
}

.submit-login:disabled {
  /* cor de fundo removida: herda de .submit-login:disabled em
     _utilities.css. */
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Links extras com contraste AAA */
#div-links {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 0.5rem;
}

#div-links a {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--roxo-primario);
  text-decoration: none;
  transition: color 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

#div-links a:hover {
  color: var(--roxo-medio);
  text-decoration: underline;
}

#div-validacao {
  border: none;
  color: var(--vermelho);
  font-size: 0.85rem;
  text-align: center;
  font-weight: 600;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 500px) {
  .form-entrar {
    padding: 2rem 1.2rem;
    max-width: 100%;
  }

  .form-entrar h1 {
    font-size: 1.5rem;
  }

  .submit-login {
    padding: 0.85rem;
    font-size: 0.95rem;
  }

  #div-links {
    gap: 0.5rem;
  }
}
</style>
